import { SecondaryStyling } from './secondary-styling';

export const DEFAULT_SECONDARY_STYLING: SecondaryStyling = {
  enabled: false,
};

export function isEmptySecondaryStyling(secondaryStyling?: SecondaryStyling): boolean {
  return !secondaryStyling?.rules?.length;
}

export function isSecondaryStylingEnabled(secondaryStyling?: SecondaryStyling): boolean {
  return (!isEmptySecondaryStyling(secondaryStyling) && secondaryStyling?.enabled) ?? false;
}

export function isDefaultSecondaryStyling(secondaryStyling?: SecondaryStyling): boolean {
  // Intentionally not checking for empty rules and sample metrics, as we want to consider secondary styling as default if it's disabled
  return (
    secondaryStyling === undefined ||
    secondaryStyling?.enabled === DEFAULT_SECONDARY_STYLING.enabled
  );
}
